import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useOrgType } from '../hooks/useOrgType';
import { toast } from 'react-toastify';

// /////////////////////////////////////////////////////////////////////////////////////////////////
// Missing flags are treated as enabled (true)
function readFlag(flags, key) {
  if (!key) return true;
  return Object.prototype.hasOwnProperty.call(flags || {}, key) ? !!flags[key] : true; // default enabled when absent
}

// /////////////////////////////////////////////////////////////////////////////////////////////////
function hasAccess(flags, { flag, anyOf = [], allOf = [] }) {
  const bySingle = flag ? readFlag(flags, flag) : true;
  const byAny = anyOf.length ? anyOf.some((k) => readFlag(flags, k)) : true;
  const byAll = allOf.length ? allOf.every((k) => readFlag(flags, k)) : true;
  return bySingle && byAny && byAll;
}

// /////////////////////////////////////////////////////////////////////////////////////////////////
export default function FeatureGate({ flag, anyOf = [], allOf = [], children, redirectTo = '/home' }) {
  const { entityId, featureFlags } = useOrgType();
  const location = useLocation();

  // Avoid false "blocked" flicker while org/flags are initializing
  if (!entityId) {
    return <div style={{ height: 1 }} />;
  }

  const allowed = hasAccess(featureFlags, { flag, anyOf, allOf });

  if (!allowed) {
    toast.info(`Feature "${flag}" is not enabled for your organization.`);
    return <Navigate replace to={redirectTo} state={{ from: location, reason: 'feature_disabled' }} />;
  }

  return children ?? <Outlet />;
}
